import SearchInput from 'threads5/SearchInput';
import styled from 'threads5/themes/styled';
import type { ICareersSearchFilterProps } from './CareersSearch.types';

const StyledSearchInput = styled(SearchInput)(({ theme }) => {
  return {
    width: '100%',
    flexGrow: 1,
    input: {
      marginBottom: 0,
      border: 'none',
      outline: 'none',
      ':focus': {
        border: 'none',
        outline: 'none',
      },
    },
    '.MuiInputAdornment-root': {
      minHeight: '46px',
    },
    '.MuiInputBase-input, .MuiOutlinedInput-notchedOutline': {
      height: '46px !important',
    },
    [theme.breakpoints.up('md')]: {
      width: 'auto',
    },
  };
});

const CareersSearchFilter = ({
  value,
  onChange,
  sx,
}: ICareersSearchFilterProps) => {
  return (
    <StyledSearchInput
      id='search'
      label='Find a role'
      value={value}
      onChange={onChange}
      hasClearButton={false}
      endAdornment={null} // needed otherwise there's an empty container
      size={48}
      sx={sx}
    />
  );
};

export default CareersSearchFilter;
